<template>
  <form id="editar-clave">
    <div class="row justify-center">
      <b-alert
        dismissible
        variant="success"
        :show="showSuccessAlert"
      >
        <div class="alert-body">
          <span>Su clave ha sido actualizada correctamente!</span>
        </div>
      </b-alert>
    </div>
    <div class="vx-row mb-1">
      <div class="vx-col w-full">
        <vs-input
          v-validate="'required|min:4|max:20'"
          autocomplete
          class="w-full"
          icon-pack="material-icons"
          icon="vpn_key"
          icon-no-border
          type="password"
          data-vv-as="Clave actual"
          placeholder="************"
          label="Clave actual"
          name="actualPassword"
          :danger="errors.has('actualPassword')"
          :danger-text="errors.first('actualPassword')"
          v-model="actualPassword"
          @input="input('actualPassword', $event)"
        />
      </div>
    </div>
    <div class="vx-row mb-1">
      <div class="vx-col w-full">
        <vs-input
          v-validate="'required|min:4|max:20'"
          ref="newPassword"
          autocomplete
          class="w-full"
          icon-pack="material-icons"
          icon="vpn_key"
          icon-no-border
          type="password"
          data-vv-as="Clave nueva"
          label="Clave nueva"
          placeholder="************"
          name="newPassword"
          v-model="newPassword"
          :danger="errors.has('newPassword')"
          :danger-text="errors.first('newPassword')"
          @input="input('newPassword', $event)"
        />
      </div>
    </div>
    <div class="vx-row mb-1">
      <div class="vx-col w-full">
        <vs-input
          v-validate="'required|confirmed:newPassword|min:4|max:20'"
          autocomplete
          class="w-full"
          icon-pack="material-icons"
          icon="vpn_key"
          icon-no-border
          type="password"
          data-vv-as="Repita clave nueva"
          label="Repita clave nueva"
          placeholder="************"
          name="confirmationNewPassword"
          v-model="confirmationNewPassword"
          :danger="errors.has('confirmationNewPassword')"
          :danger-text="errors.first('confirmationNewPassword')"
          @input="input('confirmationNewPassword', $event)"
        />
      </div>
    </div>
    <div class="vs-row">
      <vs-col vs-offset="2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="8">
        <vx-tooltip text="Al hacer click se modificara su clave" position="top">
          <vs-button
            :disabled="!formValid()"
            class="mt-5"
            type="border"
            @click="modificarClave"
          >
            Cambiar
          </vs-button>
        </vx-tooltip>
        <vs-button
          v-show="showSuccessAlert && isUpdateBySystem"
          class="mt-5 ml-3"
          color="success"
          @click="$router.push({ name: 'iniciando' })"
        >
          Continuar
        </vs-button>
      </vs-col>
    </div>
  </form>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

import { updatePassword } from '@/febos/servicios/api/usuarios.api';

export default {
  components: {},
  props: {
    isUpdateBySystem: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      actualPassword: '',
      newPassword: '',
      confirmationNewPassword: '',
      showSuccessAlert: false
    };
  },
  computed: {
    ...mapGetters('Usuario', [
      'currentUser'
    ])
  },
  methods: {
    ...mapActions('Usuario', [
      'updateProfile'
    ]),
    input(key, value) {
      this[key] = value;
    },
    formValid() {
      return this.actualPassword.trim()
        && this.newPassword.trim()
        && this.confirmationNewPassword.trim()
        && (this.newPassword === this.confirmationNewPassword);
    },
    async modificarClave() {
      if (this.formValid()) {
        const response = await updatePassword({
          claveActual: this.actualPassword,
          claveNueva: this.newPassword
        });
        const successResponse = response.data.codigo === 10 || response.data.codigo === '10';
        if (successResponse) {
          this.showSuccessAlert = true;
        }
      }
    }
  }
};
</script>
